import React, { useState } from 'react';
import axios from 'axios';


const getCookie = (name) => {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}

const isLoggedIn = () => {
    const token = getCookie('authToken');
    console.log("is logged in");
    console.log(token);
    console.log(token !== undefined);
    return true;
}

const Login = ({onLogin}) => {

    const backendUrl = process.env.REACT_APP_DOMAIN_BACKEND; // Get domain from environment variable

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleLoginButton = async () => {
        try {
            const response = await axios.post(`${backendUrl}/ajaxController.php?action=login`, {
                username,
                password
            });

            // Assuming the backend returns an authentication token
            const authToken = response.data.token;


            // Store the authentication token in a cookie
            document.cookie = `authToken=${authToken}; path=/; Secure; HttpOnly`;
            onLogin();

            // Redirect to the home page or perform any other action
            // window.location.href = '/home';
        } catch (error) {
            console.error('Login failed:', error);
        }
    };

    return (
        <div className="login-container">
            <input className="form-control" type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
            <input className="form-control" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
            <button className="btn btn-primary" onClick={handleLoginButton}>Login</button>
        </div>
    );
};

export {Login, isLoggedIn};
